import { render, staticRenderFns } from "./fourth.vue?vue&type=template&id=d39a3f0a&scoped=true&"
import script from "./fourth.vue?vue&type=script&lang=js&"
export * from "./fourth.vue?vue&type=script&lang=js&"
import style0 from "./fourth.vue?vue&type=style&index=0&id=d39a3f0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39a3f0a",
  null
  
)

export default component.exports